import { actions, isProjectFullBlocked } from 'entities';

import { UserPenIcon, UserXIcon } from 'components/Icons';

import { registerTaskOption } from '../options';
import { useTaskOwnerChange } from './changeTaskOwner.hook';
import { useSingleJustification } from 'providers/Justification';

registerTaskOption({
  Icon: UserPenIcon,

  action: 'CHANGE_OWNER',

  getLabel: (t) => t('change-owner'),

  shortcutKey: 'O',

  useOption: ({ project, updateTask, task }) => {
    const { canChangeOwner, handleChangeClick, loading } = useTaskOwnerChange({
      task,
      type: 'owner',
      onNewOwner: (owner) => updateTask({ owner }),
    });

    return {
      action: handleChangeClick,

      loading,

      isEnabled: canChangeOwner && !isProjectFullBlocked(project.status),
    };
  },
});

registerTaskOption({
  Icon: UserPenIcon,

  action: 'CHANGE_SUB_OWNER',

  shortcutKey: 'S',

  useOption: ({ project, updateTask, task }) => {
    const { canChangeOwner, handleChangeClick, loading } = useTaskOwnerChange({
      task,
      type: 'subOwner',
      onNewOwner: (subOwner) => updateTask({ subOwner }),
    });

    return {
      action: handleChangeClick,

      loading,

      isEnabled: canChangeOwner && !isProjectFullBlocked(project.status),

      getLabel: (t) => (task.subOwner ? t('change-sub-owner') : t('add-sub-owner')),
    };
  },
});

registerTaskOption({
  Icon: UserXIcon,

  action: 'REMOVE_SUB_OWNER',

  shortcutKey: 'K',

  useOption: ({ project, updateTask, task }) => {
    const { canChangeOwner } = useTaskOwnerChange({
      task,
      type: 'subOwner',
    });

    const changeOwnership = actions.projects.changeTaskOwnership.use({
      onSuccess: () => updateTask({ subOwner: undefined }),
    });

    const action = useSingleJustification({
      onConfirm: (justification) =>
        changeOwnership.execute({
          justification,
          project: task.projectId,
          task: task.id,
          subOwner: null,
        }),
    });

    return {
      action,

      loading: changeOwnership.loading,

      isEnabled: canChangeOwner && !isProjectFullBlocked(project.status) && !!task.subOwner,

      getLabel: (t) => t('remove-sub-owner'),
    };
  },
});
